// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2zRUJ","content-wrap":"styles_content-wrap__3OXKM"};